import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { WhatsAppIcon } from './SocialIcons';
export function FloatingButtons() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <>
      {/* WhatsApp Floating Button */}
      <a href="https://wa.me/573015892967" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 w-[60px] h-[60px] bg-[#25D366] rounded-full flex items-center justify-center z-[9999] animate-pulse-whatsapp hover:scale-110 transition-transform duration-300 group" aria-label="Contactar por WhatsApp" data-id="element-165">
        <WhatsAppIcon size={30} className="text-white" data-id="element-166" />

        {/* Tooltip */}
        <span className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-white text-primary text-sm font-bold py-2 px-4 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none hidden md:block" data-id="element-167">
          ¡Agenda tu cita gratis!
          {/* Tooltip Arrow */}
          <span className="absolute top-1/2 -translate-y-1/2 -right-2 border-8 border-transparent border-l-white" data-id="element-168"></span>
        </span>
      </a>

      {/* Scroll to Top Button */}
      <button onClick={scrollToTop} className={`fixed bottom-6 left-6 w-[45px] h-[45px] bg-gold rounded-full flex items-center justify-center z-[9998] hover:bg-gold-hover transition-all duration-300 shadow-lg ${showScrollTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}`} aria-label="Volver arriba" data-id="element-169">
        <ArrowUp size={24} className="text-primary" strokeWidth={2.5} data-id="element-170" />
      </button>
    </>;
}